import React from 'react'
import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'

import Button from 'components/UI/Button'

import './user-edit-message.pcss'

const UserEditMessage = ({ sectionType, onClick }) => {
    const { t } = useTranslation(['editProfile'])

    const userMessage = () => {
        let message = null
        switch (sectionType) {
        case 'UserPrimaryData':
            message = (
                <Trans i18nKey="editProfile:details.primary.fields.mobile.text">
                    Kun vahvistat puhelinnumerosi, voit lähettää viestejä muille käyttäjille.
                    <Button
                        type="button"
                        className="button button--tertiary"
                        onClick={onClick}
                        trackName="terms"
                    >
                        Vahvista puhelinnumerosi nyt
                    </Button>
                </Trans>
            )
            break
        case 'UserOwnInfoData':
            message = (
                <Trans i18nKey="editProfile:details.ownInfo.fields.preferredTimeOfContact.placeholder">
                    Voit halutessasi kertoa ajankohdasta lyhyesti.
                </Trans>
            )
            break
        case 'UserOwnInfoDataWithPhoneNumverVisibility':
            message = t('editProfile:details.ownInfo.fields.isShowPhoneNumber.description')
            break
        }

        return message
    }

    return userMessage && (
        <div className="user-edit-message message">
            {userMessage()}
        </div>
    )
}

UserEditMessage.propTypes = {
    sectionType: PropTypes.string.isRequired,
}

export default UserEditMessage
